

























import { Component, Vue, Prop } from 'vue-property-decorator';
import Button from '@/components/Button.vue';
import NewTranslation from '@/components/i18n/NewTranslation.vue';
import BillingAddress from '@/components/payment-forms/BillingAddressForm.vue';
import PaymentData from '@/types/store/checkout/PaymentData';

@Component({
  components: {
    Button,
    NewTranslation,
    BillingAddress,
  },
})
export default class CreditcardForm extends Vue {
  @Prop(Boolean)
  public paymentIsLoading: boolean = false;

  public iframeOrigin = 'https://cc.secupay.com';

  public owner: string = '';

  public firstname: string = '';

  public lastname: string = '';

  public email: string = '';

  public async created() {
    this.iframeMessageListener();
  }

  public setOwner() {
    const iframeElement = document.getElementById('iframe-secupay');
    if (!iframeElement) return;
    // @ts-ignore
    const iframeContentWindow = iframeElement.contentWindow;
    iframeContentWindow.postMessage({ action: 'set-theme', theme: 0 }, this.iframeOrigin);
    iframeContentWindow.postMessage({ action: 'set-owner', owner: this.owner }, this.iframeOrigin);
  }

  private iframeMessageListener() {
    const component = this;
    window.addEventListener(
      'message',
      event => {
        const iframeElement = document.getElementById('iframe-secupay');
        if (!iframeElement) return;
        switch (event.data.action) {
          case 'cc-iframe-height': // Iframe height changed. This is raised on load, and after validation.
            // @ts-ignore
            iframeElement.height = event.data.documentHeight + 'px';
            break;
          case 'prepared-cc-data': // Iframe sends data. These may be valid or not.
            component.updateData(event.data.data);
            break;
          default:
            break;
        }
      },
      false
    );
  }

  private updateBillingAddress(data: PaymentData) {
    this.firstname = data.firstname;
    this.lastname = data.lastname;
    this.owner = `${this.firstname} ${this.lastname}`;
    this.email = data.email;
    this.setOwner();
  }

  public getDataFromIframe() {
    const iframeElement = document.getElementById('iframe-secupay');
    if (!iframeElement) return;
    // @ts-ignore
    const iframeContentWindow = iframeElement.contentWindow;

    iframeContentWindow.postMessage({ action: 'get-cc-data' }, this.iframeOrigin); // will callback updateData
  }

  private async updateData(creditCardData: any): Promise<void> {
    const data = {
      firstname: this.firstname,
      lastname: this.lastname,
      email: this.email,
      creditCardData: creditCardData,
    };
    this.$emit('update-data', data);
    if (creditCardData.allFieldsAreValid) this.$emit('submit');
  }
}
